<template>
  <div>
    <div class="card">
      <div class="card-header"><h4>Cadastrar Serviço</h4></div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <label for="nome">Nome</label>
            <input
              id="nome"
              type="text"
              class="form-control"
              placeholder="Digite um nome:"
              v-model="state.nome"
            />
          </div>
          <div class="col-md-4">
            <label for="desc">Descrição</label>
            <input
              id="desc"
              type="email"
              class="form-control"
              placeholder="Digite uma descrição:"
              v-model="state.descricao"
            />
          </div>
          <div class="col-md-4">
            <label for="status">Status</label>
            <select v-model="state.status" class="form-select">
              <option value="ATIVO">Ativo</option>
              <option value="INATIVO">Inativo</option>
            </select>
          </div>
          <div class="col-md-6">
            <label for="status">Categoria</label>
            <select v-model="state.categoria_id" class="form-select">
              <option
                v-for="categoria in state.categorias"
                :key="categoria.id"
                :value="categoria.id"
              >
                {{ categoria.nome }}
              </option>
            </select>
          </div>
          <div class="col-md-6">
            <label for="texto">Texto</label>
            <textarea
              id="texto"
              class="form-control"
              v-model="state.texto"
            ></textarea>
          </div>
          <div class="col-md-8">
            <label>Imagem</label>
            <input type="file" class="form-control" @change="adicionarImagem" />
          </div>
          <div
            style="display: flex"
            class="col-md-4"
            v-if="state.imagem.imagem"
          >
            <img :src="state.imagem.imagem" class="imagem" />
            <button class="btn_deletar_imagem" @click="removerImagem">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                fill="currentColor"
                class="bi bi-x-lg mb-2"
                viewBox="0 0 16 16"
              >
                <path
                  d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"
                />
              </svg>
            </button>
          </div>
        </div>
        <div class="btns_right">
          <button @click="salvarServico" type="button" class="btn_save">
            Salvar
          </button>
          <router-link to="/admin/servicos">
            <button type="button" class="btn_cancel">Cancelar</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      id: "",
      nome: "",
      descricao: "",
      texto: "",
      status: "ATIVO",
      categoria_id: "",
      categorias: "",
      imagem: {},
    });
    onMounted(() => {
      fetchCategorias();
      if (router.currentRoute._value.params.id != undefined) {
        fetchServico();
      }
    });
    async function fetchCategorias() {
      try {
        const { data } = await services.categoria.getAll({ token });
        console.log(data);
        state.categorias = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function fetchServico() {
      try {
        const { data } = await services.servicos.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.id = data.id;
        state.nome = data.nome;
        state.descricao = data.descricao;
        state.texto = data.texto;
        state.status = data.status;
        state.categoria_id = data.categoria_id;
        if (data.imagem != null) {
          state.imagem.imagem = data.imagem;
        }
      } catch (error) {
        console.log(error);
      }
    }
    async function salvarServico() {
      let dados = new FormData();
      dados.append("nome", state.nome);
      dados.append("descricao", state.descricao);
      dados.append("texto", state.texto);
      dados.append("status", state.status);
      dados.append("categoria_id", state.categoria_id);
      if (state.imagem.file != null) {
        dados.append("imagem", state.imagem.file);
      }
      if (!state.id) {
        try {
          await services.servicos.save(dados, token);
          router.push({ name: "Servicos" });
        } catch (error) {
          console.log(error);
        }
      } else {
        dados.append("id", state.id);
        dados.append("_method", "PATCH");
        if (state.imagem.imagem == undefined) {
          try {
            await services.servicos.deletarImagem({
              id: dados.get("id"),
            });
          } catch (error) {
            console.log(error);
          }
        }
        try {
          await services.servicos.update(dados, token);
          router.push({ name: "Servicos" });
        } catch (error) {
          console.log(error);
        }
      }
    }
    async function adicionarImagem(event) {
      var img = event.target.files[0];
      var objImagem = new Object();
      objImagem.file = img;
      objImagem.imagem = URL.createObjectURL(img);
      state.imagem = objImagem;
    }
    async function removerImagem() {
      state.imagem = {};
      document.querySelector('input[type="file"]').value = null;
    }
    return {
      salvarServico,
      removerImagem,
      adicionarImagem,
      router,
      state,
    };
  },
};
</script>
<style scoped>
h4 {
  color: #000;
}
label {
  color: #000;
  font-size: 12pt;
  margin-bottom: 0;
  margin-top: 5px;
}
input {
  border: solid 1px #000;
}
input:focus {
  border: solid 1px #8b0000;
}
select {
  border: solid 1px #000;
}
select:focus {
  border: solid 1px #8b0000;
}
textarea {
  resize: none;
  border: solid 1px #000;
}
textarea:focus {
  border: solid 1px #8b0000;
}
.btns_right {
  text-align: right;
  margin-top: 5rem;
}
.btn_save {
  padding: 5px;
  width: 100px;
  background: #00a000;
  border: solid 2px #000;
  border-radius: 5px;
  transition: 0.2s;
}
.btn_save:hover {
  background: #008000;
}
.btn_cancel {
  padding: 5px;
  width: 100px;
  background: #c4342d;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn_cancel:hover {
  background: #8f0303;
}
.imagem {
  width: 100%;
  object-fit: cover;
  margin-top: 1rem;
}
.btn_deletar_imagem {
  width: 25px;
  height: 25px;
  margin-left: 3px;
  background: #8b0000;
  color: #fff;
  border: solid 1px #8b0000;
  border-radius: 5px;
  transition: 0.3s;
  margin-top: 1rem;
}
.btn_deletar_imagem:hover {
  background: rgb(228, 0, 0);
  color: #fff;
  border: solid 1px rgb(228, 0, 0);
}
.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}
</style>